export default __webpack_public_path__ + "static/SegoeUI-Mono-Bold-5df47711ec9c58bc13b1ef488e55f98b.ttf";